const projectsDataFilePath = "data/map_data.json";
const grantsDataFilePath = "data/grants_data.json";
const settingsDataFilePath = "data/settings.json";

const dataURLs = {
    projects: `${process.env.PUBLIC_URL}/${projectsDataFilePath}`,
    grants: `${process.env.PUBLIC_URL}/${grantsDataFilePath}`,
    settings: `${process.env.PUBLIC_URL}/${settingsDataFilePath}`,
};

export const getData = () => fetch(dataURLs.projects).then(res => res.json());
export const getGrantsData = () => fetch(dataURLs.grants).then(res => res.json());
export const getSettingsData = () => fetch(dataURLs.settings).then(res => res.json());



// WEBPACK FOOTER //
// ./src/api/index.js